import { ImmunizationCovidViewNew } from "./ImmunizationCovidViewNew";

export default ImmunizationCovidViewNew;
